var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error_box"},_vm._l((_vm.errorItems),function(item){return _c('Error',{key:item.id,attrs:{"message":item.message,"errorId":item.id,"actionType":item.actionType,"actionPayload":item.actionPayload},on:{"closeError":_vm.closeError}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }